import React from "react";
import Field from "src/components/common/FormComponents/Field";
import { EmailFieldProps } from "src/components/Feedback/components/types";
import { VALIDATION_EMAIL } from "src/utils/constant/constant";

const FieldEmail: React.FC<EmailFieldProps> = ({ errors, register }) => {
  return (
    <Field
      type="email"
      error={errors.email?.message}
      register={register("email", {
        required: "Введите адрес электронной почты",
        pattern: {
          value: VALIDATION_EMAIL,
          message: "Неверный формат электронной почты",
        },
      })}
      fullWidth
    />
  );
};

export default FieldEmail;
